/**
 * Schemas for the `ticker.list` tRPC procedure.
 *
 * Ticker items are short, locale-resolved blurbs surfaced in the running
 * bar across the top of every page. The query filters out expired items
 * (`expiresAt > now()` or null) and returns the most-recent N. Cached
 * for 10 seconds — short enough to feel live, long enough to absorb
 * traffic spikes during a breaking story.
 */

import { z } from "zod";

export const TICKER_SEVERITIES = ["info", "caution", "urgent"] as const;
export const tickerSeveritySchema = z.enum(TICKER_SEVERITIES);
export type TickerSeverity = z.infer<typeof tickerSeveritySchema>;

export const tickerItemSchema = z.object({
  id: z.number().int(),
  outbreakId: z.number().int().nullable(),
  /** Locale-resolved text. */
  text: z.string(),
  link: z.string().nullable(),
  severity: tickerSeveritySchema,
  publishedAt: z.date(),
  expiresAt: z.date().nullable(),
});
export type TickerItemOut = z.infer<typeof tickerItemSchema>;

export const tickerListInputSchema = z.object({
  limit: z.number().int().min(1).max(20).default(8),
});
export type TickerListInput = z.infer<typeof tickerListInputSchema>;

export const tickerListOutputSchema = z.array(tickerItemSchema);
